import type { Toast } from 'store';
import { createAction } from 'typesafe-actions';

import { ADD_TOAST, DISMISS_TOAST } from './constants';

export const addToast = createAction(ADD_TOAST, (payload: Toast) => payload)();
export const dismissToast = createAction(DISMISS_TOAST, (id: string) => id)();
